import { getData, saveDataIntoAsyncStore } from "./commons";

export const cached = {
    setContactInfo,
    getContactInfo,
    setAddressInfo,
    getAddressInfo,
    setBillinginfo,
    getBillingInfo,
}

function setContactInfo(data) {
    data = JSON.stringify(data)
    saveDataIntoAsyncStore('cache_contact_info',data);
}

function getContactInfo() {
    let data = getData('cache_contact_info');
    try {
        if (data) {
            data = JSON.parse(data);
        }
    } catch (error) {
        console.log("getContactInfo error: ", error)
    }
    return data;
}

function setAddressInfo(data) {
    data = JSON.stringify(data)
    saveDataIntoAsyncStore('cache_address_info',data);
}

function getAddressInfo() {
    let data = getData('cache_address_info');
    try {
        if (data) {
            data = JSON.parse(data);
        }
    } catch (error) {
        console.log("getAddressInfo error: ", error)
    }
    return data;
}

function setBillinginfo(data) {
    data = JSON.stringify(data);
    saveDataIntoAsyncStore('cached_billing_info', data);
}

function getBillingInfo() {
    let data = getData('cached_billing_info');
    try {
        if (data) {
            data = JSON.parse(data);
        }
    } catch (error) {
        console.log("getBillingInfo error: ", error)
    }
    return data;
}